export const formatContentToHTML = (data: any) => {
    if (!data || typeof data !== "string") return data;

    if (data.includes("<p>") || data.includes("<br")) return data;

    return data
        .split(/\r?\n/)
        .filter((line: string) => line.trim() !== "")
        .map((line: string) => `<p>${line.trim()}</p>`)
        .join("");
}